import React from 'react';
import _ from 'lodash';

import { useRepairCodeSelectFieldQuery } from 'generated/graphql';



export interface IRepairCode {
  id: string;
  repairCode: string;
}

export interface IData {
  objects: IRepairCode[];
}

export function useQuery(storeId: string) {
  const queryTuple = useRepairCodeSelectFieldQuery({
    variables: {
      storeId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.store?.repairCodes ?? [], (node): IRepairCode => ({
        id: node.id,
        repairCode: node.repairCode
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
